import {SEARCH_FOR_SET_NEW_QUERY, SEARCH_FOR_SET_RESULTS} from '../actions';
import queryString from 'query-string';

export function searchForSet(state = null, action) {
  const locationQuery = queryString.parse(location.search);

  let nextState = state || {
    query: (locationQuery.q || ''),  // eslint-disable-line id-length
    results: {hits: [], hitsPerPage: 0, count: 0},
  };

  if (action.type === SEARCH_FOR_SET_NEW_QUERY) {
    nextState = Object.assign(
      {},
      state,
      {query: action.query}
    );
  }

  if (action.type === SEARCH_FOR_SET_RESULTS) {
    const {hits, hitsPerPage, count} = action;

    nextState = Object.assign(
      {},
      state,
      {results: {hits, hitsPerPage, count}}
    );
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/views/Sets/reducers/index.js